import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { LangProvider } from "@/context/LangContext";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import {
  TreatmentsPage, TreatmentDetail,
  HospitalsPage, HospitalDetail,
  DoctorsPage, ServicesPage, AboutPage,
  BlogPage, BlogDetail, ContactPage,
} from "@/pages/StaticPages";
import { AdminLogin, AdminDashboard } from "@/pages/Admin";

function Site({ children }) { return <SiteLayout>{children}</SiteLayout>; }

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Site><Home /></Site>} />
            <Route path="/treatments" element={<Site><TreatmentsPage /></Site>} />
            <Route path="/treatments/:slug" element={<Site><TreatmentDetail /></Site>} />
            <Route path="/hospitals" element={<Site><HospitalsPage /></Site>} />
            <Route path="/hospitals/:hid" element={<Site><HospitalDetail /></Site>} />
            <Route path="/doctors" element={<Site><DoctorsPage /></Site>} />
            <Route path="/services" element={<Site><ServicesPage /></Site>} />
            <Route path="/about" element={<Site><AboutPage /></Site>} />
            <Route path="/blog" element={<Site><BlogPage /></Site>} />
            <Route path="/blog/:slug" element={<Site><BlogDetail /></Site>} />
            <Route path="/contact" element={<Site><ContactPage /></Site>} />
            <Route path="/admin/login" element={<Site><AdminLogin /></Site>} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<Site><Home /></Site>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}
